export default __webpack_public_path__ + "static/media/thaiam.50c436c4.png";